module.exports = __webpack_public_path__ + "media/images/icons/filled/idcard-1e8996cf1ad15f88c7663b02d57f1392.svg";